import { render, staticRenderFns } from "./BranchTransactionDetail.vue?vue&type=template&id=04ed7783&"
import script from "./BranchTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./BranchTransactionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ed7783')) {
      api.createRecord('04ed7783', component.options)
    } else {
      api.reload('04ed7783', component.options)
    }
    module.hot.accept("./BranchTransactionDetail.vue?vue&type=template&id=04ed7783&", function () {
      api.rerender('04ed7783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BranchTransactionDetail.vue"
export default component.exports